import { Component } from '@angular/core';
import { TourService } from '@services/tour.service';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
@Component({
    selector: 'app-quick-help',
    templateUrl: './quick-help.component.html',
    styleUrls: ['./quick-help.component.scss'],
    standalone: false
})
export class QuickHelpComponent {
  constructor(
    private tourService: TourService,
    private dialogRef: ScaffoldDialogRef
  ) {}
  tours = [
    {
      title: 'Creating a New Integration',
      id: 'create-integration',
    },
    {
      title: 'Importing Courses',
      id: 'create-import',
    },
    {
      title: 'Updating Institution Theme',
      id: 'scaffold-theme-setup',
    },
    {
      title: 'Inviting Users',
      id: 'inviting-users',
    },
  ];

  startTour(tour): void {
    this.tourService.startTour(tour.id);
    this.dialogRef.close();
  }
}
